var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var FeatureImg = function () {
	this.$fullWidthFig = $( document.getElementsByClassName( 'full-width' ) );
	this.$fwFigcaption = $( document.querySelectorAll( 'figure.full-width figcaption' ) );
	this.$carousel = $( document.getElementsByClassName( 'carousel' ) );
	this.$moves = $( document.getElementsByClassName( 'moves' ) );
};

FeatureImg.prototype.load = function () {

	var self = this,
		$paddles,
		captionH;

	self.$carousel
		.slick( {
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true
					}
				}
			]
		} )
		.on( 'edge', function ( event, slick, direction ) {
			$( this ).slick( 'slickGoTo', "0" );
		} )
		.on( 'afterChange', function ( event, slick, direction ) {
			if ( 0 !== $( this ).slick( 'slickCurrentSlide' ) ) {
				// show back arrow
				$( this ).find( '.slick-prev' ).show();
			} else {
				$( this ).find( '.slick-prev' ).hide();
			}

			if ( $( this ).slick( 'slickCurrentSlide' ) + 4 >= $( this ).find( 'li' ).length ) {
				// hide forward arrow
				$( this ).find( '.slick-next' ).hide();
			} else {
				$( this ).find( '.slick-next' ).show();
			}
		} );

	$paddles = this.$fwFigcaption.find( '.slick-arrow' );

	$( document.querySelectorAll( '.slick-prev' ) ).hide();

	if ( $( window ).width() > 1000 ) {

		self.$fwFigcaption.each( function () {
			captionH = $( this ).find( 'li.slick-slide' ).outerHeight() - 268 - 27; // Find this value in article-body.scss and add padding
			$paddles.css( 'transform', 'translateY(-' + captionH + 'px)' );
		} );

		var open = false;

		self.$fullWidthFig.hover(
			function () {
				self.$moves.add( $( this ).children( 'img' ).siblings( 'figcaption' ) ).addClass( 'down' );
				$paddles.css( { 'transform': 'translateY(-' + 200 + 'px)', 'transition': 'transform 0.5s' } );

				open = true;
			}, function () {
				self.$moves.add( $( this ).children( 'img' ).siblings( 'figcaption' ) ).removeClass( 'down' );
				$paddles.css( 'transform', 'translateY(-' + captionH + 'px)' );

				open = false;
			}
		);
	}
};

module.exports = new FeatureImg();
